import { Routes, Route, useNavigate } from 'react-router-dom';
import FacHeader from './facilitator-components/FacHeader';
import PatientWizardMain from './facilitator-components/scenariobuilder/PatientWizard';
import ScenarioWizard from './facilitator-components/scenariobuilder/ScenarioWizard';
import FacilitatorDash from './facilitator-components/dashboard/facilitator-dash';
import FacilitatorLive from './facilitator-components/FacilitatorLiveScenario';
import SessionSummary from './facilitator-components/FacilitatorSessionSummary';
import { Typography, Button } from '@mui/material';

export default function FacilitatorApp() {
  const navigate = useNavigate();

  return (
    <div className="layout">
      <FacHeader />
      <div className="facmain">
        <Routes>
          <Route path="/" element={<FacilitatorDash />} />
          <Route path="/create/epr" element={<PatientWizardMain />} />
          <Route path="/create/scenario" element={<ScenarioWizard />} />
          <Route path="/live" element={<FacilitatorLive/>} />
          <Route path="/summary" element={<SessionSummary/>} />
        </Routes>
      </div>
      
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#F8FAFF',
        height: '20px'
      }}>
        <Typography sx={{ fontSize: 12 }}>
          © 2026, SimSuite. All rights reserved.  
        </Typography>

        <Button
          href="/credits/image"
          target="_blank"
          rel="noopener noreferrer"
          disableRipple
          sx={{
            fontSize: 12,
            minWidth: 'auto',
            padding: 0,
            marginLeft: 1,
            textTransform: 'none',
            '&:hover': {
              backgroundColor: 'transparent',
            }
          }}
        >
          Image Credits
        </Button>
        <Button
          href="/terms"
          target="_blank"
          rel="noopener noreferrer"
          disableRipple
          sx={{
            fontSize: 12,
            minWidth: 'auto',
            padding: 0,
            marginLeft: 1,
            textTransform: 'none',
            '&:hover': {
              backgroundColor: 'transparent',
            }
          }}
        >
          Terms of Use
        </Button>
        <Button
          href="/privacy"
          target="_blank"
          rel="noopener noreferrer"
          disableRipple
          sx={{
            fontSize: 12,
            minWidth: 'auto',
            padding: 0,
            marginLeft: 1,
            textTransform: 'none',
            '&:hover': {
              backgroundColor: 'transparent',
            }
          }}
        >
          Privacy policy
        </Button>
      </div>
    </div>
  );
}
